import { render, staticRenderFns } from "./Korea.vue?vue&type=template&id=28912764&scoped=true&"
import script from "./Korea.vue?vue&type=script&lang=js&"
export * from "./Korea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28912764",
  null
  
)

export default component.exports